// extracted by mini-css-extract-plugin
module.exports = {"heroFixed":"styles-module--heroFixed--W3f8u","heroImage":"styles-module--heroImage--23_zy"};